<template>
  <div class="app-tutorial flex w-full" :style="{ backgroundImage: `url(${tutorialHomeBg})` }">
    <GfrContainer class="flex">
      <CommonDocumentMenu
        :catalog="tutorialMenu"
        :prefix-path="`/${$route.params.lang}/tutorial/${$route.params.category}`"
      />
      <section class="flex-1 pt-30 lg:pt-20 max-lg:w-full">
        <NuxtPage v-if="tutorialMenu.length" />
      </section>
    </GfrContainer>
  </div>
</template>
<script lang="ts" setup>
import bg from '@/assets/images/docs_bg.jpg'
useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['docs-index-page-cache-tag'])
})
const route = useRoute()
const documentStore = useDocumentStore()
const { fetchTutorialCategory, updateActivePath } = documentStore
const { tutorialMenu, tutorialHomeList } = storeToRefs(documentStore)
const tutorialHomeBg = ref(bg)
await fetchTutorialCategory(route.params.category === 'fe' ? '1' : '0')
function updateHomePage() {
  tutorialHomeBg.value = tutorialHomeList.value[String(route.params.id)]?.cover_img || bg
}
watchEffect(() => updateActivePath(tutorialMenu.value, 'url', String(route.params.id)))
watchEffect(() => updateHomePage())

watch(
  () => route.params.category,
  async (value) => {
    await fetchTutorialCategory(value === 'fe' ? '1' : '0')
  }
)
onMounted(() => {
  if (session.getItem('layout') === 'cl') {
    navigateTo(`/${route.params.lang}/craftland/tutorial/${route.params.category}/${route.params.id}`)
  }
})
</script>
<style lang="scss" scoped>
.app-tutorial {
  //background-image: url('@/assets/images/docs_bg.jpg');
  background-position: center top;
  background-repeat: repeat-y;
}
</style>
